<script lang="ts" setup>
  import type { GPageHeaderProps } from '~/components/navigation/GPageHeader/GPageHeader.types'

  const props = withDefaults(defineProps<GPageHeaderProps>(), {
    title: '',
    disableBorder: true,
    disableBoxShadow: false,
    loading: false,
    backButtonFunc: undefined,
    hideBackButton: false,
    backgroundColor: 'white'
  })

  const boxShadow = computed(() => (props.disableBoxShadow ? 'none' : 'var(--box-shadow-sm)'))
  const borderBottom = computed(() => (props.disableBorder ? 'none' : '1px solid var(--color-base-paper)'))
  const minHeight = computed(() => (props.compact ? '0' : '88px'))
</script>

<template>
  <ion-header>
    <div class="ion-header-inner">
      <ion-toolbar>
        <ion-buttons v-if="!hideBackButton" slot="start">
          <slot name="start">
            <GBackButton :back-button-func="backButtonFunc" />
          </slot>
        </ion-buttons>
        <GToolbarSpacer v-else slot="start" />

        <slot name="default">
          <GSkeletonImage v-if="loading" class="page-title page-title-loading" />
          <h1 v-else class="page-title">{{ title }}</h1>
        </slot>

        <ion-buttons slot="end">
          <slot name="end">
            <GToolbarSpacer />
          </slot>
        </ion-buttons>
      </ion-toolbar>

      <div class="toolbar-submenu-wrapper">
        <slot name="toolbar-submenu" />
      </div>
    </div>
  </ion-header>
</template>

<style lang="scss" scoped>
  .ion-header-inner {
    background: v-bind(backgroundColor);
    border-bottom: v-bind(borderBottom);
    box-shadow: v-bind(boxShadow);
  }

  .page-title {
    @include typography-header-3;

    margin: 0 8px;
    text-align: center;
  }

  .page-title-loading {
    width: 70%;
    max-width: 320px;
    margin: auto;
  }

  :deep(.ion-toolbar-container) {
    display: flex;
  }

  ion-toolbar {
    --background: v-bind(backgroundColor);
    display: flex;
    min-height: v-bind(minHeight);
  }

  .toolbar-submenu-wrapper {
    background: v-bind(backgroundColor);
    display: flex;
  }
</style>
